const MaxWidth = () => {
  return {
    template: `
      <div style="display: flex; justify-content: center; width: 100%;">
        <div style="max-width: 500px; width: 100%;">
          <story/>
        </div>
      </div>
    `,
  };
};

export default MaxWidth;
